import { createRoot } from 'react-dom/client';

import 'styles/global.scss';
import { BackOfficeApp } from './app';
import './lib/utilities/i18n';

const container = document.getElementById('root');
const root = createRoot(container as Element);
root.render(<BackOfficeApp />);
